"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_history_1 = require("prosemirror-history");
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_view_1 = require("prosemirror-view");
var normalize_1 = require("./schema/normalize");
var basics_1 = require("./schema/basics");
var syl_plugin_1 = require("./schema/syl-plugin");
var event_1 = require("./event");
var util_1 = require("./libs/util");
var card_1 = require("./schema/card");
var keymap_1 = require("./basic/keymap/keymap");
var rule_builder_1 = require("./basic/text-shortcut/rule-builder");
var lifecycle_plugin_1 = require("./basic/lifecycle/lifecycle-plugin");
var state_1 = require("./state");
var module_1 = require("./module");
var basic_ctrl_1 = require("./basic/basic-ctrl");
var custom_ctrl_1 = require("./basic/custom-ctrl");
var decoration_1 = require("./basic/decoration");
var locale_1 = require("./locale");
var nodeViewScope = new WeakMap();
var unwrapNodeView = function (nodeView) {
    var state = nodeViewScope.get(nodeView);
    if (!state) {
        throw new Error('loss state!');
    }
    return state;
};
exports.unwrapNodeView = unwrapNodeView;
var EDITOR_CHECK = ['autocomplete', 'autoCorrect', 'autoCapitalize'];
var dispatchTransactionFactory = function (config) { return function (tr) {
    try {
        var view = config.view, emitter = config.emitter;
        // @ts-ignore
        if (!view || !view.docView || !emitter)
            return;
        var newState = view.state.apply(tr);
        view.updateState(newState);
        emitter.emit(event_1.EventChannel.LocalEvent.ON_CHANGE, new state_1.SylState(newState));
    }
    catch (err) {
        config.onError(err);
    }
}; };
// 渲染时在此读取nodeView信息
var composeNodeView = function (prev, sylPlugin, adapter, view, uniqueStore) {
    var CardCtor = sylPlugin.$NodeView;
    if (!CardCtor) {
        return prev;
    }
    var name = sylPlugin.name || sylPlugin.$controller.name;
    var nodeViewCreator = function (node, editorView, getPos) {
        var nodeView;
        // it is card type
        if (card_1.BaseCard.isPrototypeOf(CardCtor)) {
            nodeView = new CardCtor(adapter, node, name);
            if (!nodeView.renderer)
                nodeView.mount({ name: name });
        }
        else {
            // it is origin prosemirror nodeView
            nodeView = new CardCtor(adapter, node, editorView, getPos);
        }
        // TODO: 不清楚这么做的意义
        nodeViewScope.set(nodeView, {
            view: view,
            getPos: getPos
        });
        return nodeView;
    };
    if (Reflect.has(prev, name)) {
        console.warn('multiple register', sylPlugin);
    }
    prev[name] = nodeViewCreator;
    return prev;
};
var getNodeViewStringMap = function (sylPlugins, adapter, view, uniqueStore) {
    return sylPlugins.reduce(function (prev, curr) { return composeNodeView(prev, curr, adapter, view, uniqueStore); }, {});
};
/**
 * 在keymap前置SylApi
 * @param schemas
 * @param status
 */
var wrapKeymap = function (editor, keyMaps) {
    return Object.keys(keyMaps).reduce(function (result, key) {
        result[key] = function (state, dispatch, view) {
            return keyMaps[key](editor, state, dispatch, view);
        };
        return result;
    }, {});
};
// 注册传入的Plugins配置
var installPlugins = function (schemas, status) {
    var initedSylPlugins = [];
    var keyMaps = [];
    var nativePlugins = { top: [], bottom: [] };
    // 自定义属性prioritize表示是否优先注册
    var addNativePlugin = function (plugin) {
        // @ts-ignore
        plugin.spec.prioritize ? nativePlugins.top.push(plugin) : nativePlugins.bottom.push(plugin);
    };
    // 执行注册操作
    var registerPlugin = function (Ctor, props) {
        var schema = new Ctor();
        schema.init(status, props);
        initedSylPlugins.push(schema);
        var keyMap = {};
        if (schema.$controller && schema.$controller.keymap) {
            keyMap = schema.$controller.keymap;
        }
        else if (schema.Schema && schema.Schema.keymap) {
            keyMap = schema.Schema.keymap;
        }
        keyMap && keyMaps.push(wrapKeymap(status.editor, keyMap));
    };
    var registerUnionPlugin = function (Ctor, props) {
        var schema = new Ctor();
        var _a = schema.init(status.editor, props.controllerProps), _b = _a.nativePlugins, pmPlugins = _b === void 0 ? [] : _b, _c = _a.sylPlugins, sylPlugins = _c === void 0 ? [] : _c;
        pmPlugins.forEach(function (n) { return addNativePlugin(n); });
        sylPlugins.forEach(function (s) { return parsePluginConfig(s); });
    };
    // 解析传入的配置，可以是对象，SylPlugin, UnionPlugin, prosemirror plugin
    var parsePluginConfig = function (cur) {
        if (!cur)
            return;
        var props = {
            controllerProps: {}
        };
        var PluginCtor;
        // prosemirror plugin
        if (cur instanceof prosemirror_state_1.Plugin)
            return addNativePlugin(cur);
        PluginCtor = cur;
        // SylPlugin配置对象,可能是SylPlugin, SylUnionPlugin
        if (PluginCtor.plugin) {
            PluginCtor = cur.plugin;
            props.controllerProps = cur.controllerProps || {};
            props.layers = cur.layers || undefined;
        }
        // 普通的SylPlugin
        if (PluginCtor.prototype instanceof syl_plugin_1.SylPlugin) {
            registerPlugin(PluginCtor, props);
        }
        else if (PluginCtor.prototype instanceof syl_plugin_1.SylUnionPlugin) {
            return registerUnionPlugin(PluginCtor, props);
        }
    };
    schemas.forEach(parsePluginConfig);
    return {
        initedSylPlugins: initedSylPlugins,
        keyMaps: keyMaps,
        nativePlugins: nativePlugins
    };
};
// 收集Controller.command注册的内容
var collectCommands = function (adapter, initedSylPlugins) {
    initedSylPlugins.forEach(function (sylPlugin) {
        var _a;
        if (!sylPlugin.$controller)
            return;
        var plugin = sylPlugin;
        var pluginCommand = (_a = plugin.$controller) === null || _a === void 0 ? void 0 : _a.command;
        if (pluginCommand) {
            adapter.addCommand(plugin.name, pluginCommand);
        }
    });
};
// 负责执行编辑初始化，配置更新的能力
var SylConfiguration = /** @class */ (function () {
    function SylConfiguration(mount, _a) {
        var _this = this;
        var sylPlugins = _a.sylPlugins, schema = _a.schema, state = _a.state, view = _a.view, emitter = _a.emitter, store = _a.store, spellCheck = _a.spellCheck, autoFocus = _a.autoFocus, locale = _a.locale, onError = _a.onError, rest = __rest(_a, ["sylPlugins", "schema", "state", "view", "emitter", "store", "spellCheck", "autoFocus", "locale", "onError"]);
        this.onError = function (err) {
            throw err;
        };
        this.basicConfiguration = {
            keepLastLine: true,
            dropCursor: {},
            placeholder: '',
            keepWhiteSpace: undefined
        };
        this.plugins = [prosemirror_history_1.history()];
        // this cache all of card instance with property `uniqKey`, if uniqKey
        // set as string, use it as key. if uniqKey set as boolean, use name
        // as its key
        this.uniqueStore = new Map();
        this.autoFocus = false;
        this.setSpellCheck = function (spellCheck) {
            EDITOR_CHECK.forEach(function (attr) { return _this.view.dom.setAttribute(attr, spellCheck ? 'on' : 'off'); });
            _this.view.dom.setAttribute('spellcheck', spellCheck ? 'true' : 'false');
        };
        this.setBasicCtrlConfig = function (config) {
            Object.keys(config).forEach(function (key) {
                if (Object.keys(_this.basicConfiguration).includes(key)) {
                    _this.basicConfiguration[key] = config[key];
                }
            });
        };
        this.sylPlugins = sylPlugins || [];
        this.store = store || new Map([['renderType', 'default']]);
        this.mount = mount;
        this.autoFocus = Boolean(autoFocus);
        this.localStore = new locale_1.LocaleStore(locale);
        this.setBasicCtrlConfig(__assign({}, rest));
        this.schema = schema || normalize_1.createSchema(basics_1.basicSchema);
        var newState = state || prosemirror_state_1.EditorState.create({ schema: this.schema, plugins: this.plugins });
        this.proseProps = {
            state: newState,
            dispatchTransaction: dispatchTransactionFactory(this)
        };
        this.view = view || new prosemirror_view_1.EditorView(this.mount, this.proseProps);
        if (onError)
            this.onError = onError;
        this.setSpellCheck(spellCheck);
        this.emitter = emitter || new event_1.EventChannel();
    }
    SylConfiguration.prototype.update = function (config) {
        if (config.spellCheck)
            this.setSpellCheck(config.spellCheck);
        if (config.onError)
            this.onError = config.onError;
        this.setBasicCtrlConfig(config);
        this.view.dispatch(this.view.state.tr);
    };
    SylConfiguration.prototype.setProseProps = function (props) {
        this.proseProps = __assign(__assign({}, this.proseProps), props);
        this.view.setProps(props);
    };
    SylConfiguration.prototype.install = function (adapter, SylPlugins) {
        var _a = installPlugins(SylPlugins, {
            store: this.store,
            editor: adapter
        }), initedSylPlugins = _a.initedSylPlugins, keyMaps = _a.keyMaps, nativePlugins = _a.nativePlugins;
        collectCommands(adapter, initedSylPlugins);
        this.sylPlugins = initedSylPlugins;
        this.initPMPlugin(adapter, keyMaps, this.sylPlugins, nativePlugins);
        var schema = normalize_1.createSchema(normalize_1.updateSchema(this.schema.spec, this.sylPlugins.map(function (p) { return p && p.$schemaMeta; }).filter(function (p) { return p; })));
        var newProseState = prosemirror_state_1.EditorState.create({
            schema: schema,
            plugins: this.plugins
        });
        this.setProseProps({
            state: newProseState,
            nodeViews: getNodeViewStringMap(this.sylPlugins, adapter, this.view, this.uniqueStore)
        });
        this.autoFocus && this.view.focus();
        this.emitter.emit(event_1.EventChannel.LocalEvent.EDITOR_CREATED);
    };
    SylConfiguration.prototype.initPMPlugin = function (adapter, keyMaps, sylPlugins, nativePlugins) {
        var _a;
        var $schemaMetas = this.sylPlugins.map(function (p) { return p && p.$schemaMeta; }).filter(function (p) { return p; });
        var $controllerMetas = this.sylPlugins.map(function (p) { return p && p.$controller; }).filter(function (p) { return p; });
        var textShortCutPlugin = rule_builder_1.ruleBuilder($schemaMetas, $controllerMetas);
        var CustomCtrlPlugin = custom_ctrl_1.CreateCustomCtrlPlugin(sylPlugins.reduce(function (result, plugin) {
            if (plugin) {
                // 收集props，优先获取controller配置
                if (plugin.$controller && plugin.$controller.eventHandler) {
                    result.push({ props: plugin.$controller.eventHandler });
                }
                else if (plugin.$schemaMeta && plugin.$schemaMeta.config) {
                    result.push(plugin.$schemaMeta.config);
                }
            }
            return result;
        }, []), adapter);
        (_a = this.plugins).push.apply(_a, __spreadArrays(nativePlugins.top, [textShortCutPlugin,
            CustomCtrlPlugin], keymap_1.getKeymapPlugins(keyMaps), [decoration_1.DecorationPlugin(),
            basic_ctrl_1.BasicCtrlPlugin(this.basicConfiguration)], nativePlugins.bottom, [lifecycle_plugin_1.createLifeCyclePlugin(adapter)]));
    };
    SylConfiguration.prototype.updateState = function (sylState) { };
    SylConfiguration.prototype.uninstall = function () {
        this.view.destroy();
    };
    return SylConfiguration;
}());
// 对外暴露的配置调用接口，实际上操作在SylConfiguration中进行
var SylConfigurator = /** @class */ (function () {
    function SylConfigurator(mount, SylPlugins, initialState) {
        if (initialState === void 0) { initialState = {}; }
        this.SylPlugins = [];
        this.modules = null;
        this.mount = mount;
        this.SylPlugins = SylPlugins;
        this.configuration = new SylConfiguration(this.mount, initialState);
    }
    SylConfigurator.prototype.updateConfig = function (config) {
        return this.configuration.update(config);
    };
    SylConfigurator.prototype.emit = function (event) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return (_a = this.configuration.emitter).emit.apply(_a, __spreadArrays([event], args));
    };
    SylConfigurator.prototype.getLocaleValue = function (name) {
        return this.configuration.localStore._get(name);
    };
    SylConfigurator.prototype.setLocale = function (locale) {
        if (!locale)
            return;
        this.configuration.localStore._set(locale);
        return this.emit(event_1.EventChannel.LocalEvent.LOCALE_CHANGE);
    };
    SylConfigurator.prototype.on = function (event, handler) {
        return this.configuration.emitter.on(event, handler);
    };
    SylConfigurator.prototype.off = function (event, handler) {
        return this.configuration.emitter.off(event, handler);
    };
    SylConfigurator.prototype.install = function (adapter, modules) {
        if (modules === void 0) { modules = {}; }
        if (!this.configuration || !util_1.Utils.isEmpty(this.configuration.sylPlugins))
            return;
        this.modules = new module_1.ModuleManager(adapter, modules);
        this.configuration.install(adapter, this.SylPlugins);
        this.modules.install();
    };
    SylConfigurator.prototype.getSylPlugins = function () {
        return this.configuration.sylPlugins;
    };
    SylConfigurator.prototype.uninstall = function () {
        this.emit(event_1.EventChannel.LocalEvent.EDITOR_WILL_UNMOUNT);
        this.configuration.uninstall();
        this.modules && this.modules.uninstall();
    };
    return SylConfigurator;
}());
exports.SylConfigurator = SylConfigurator;
//# sourceMappingURL=configurator.js.map